<template>
  <SealAdminTable />
</template>

<script lang="ts" setup>
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import { useCompanySealEntriesData } from '@/composables/deepsign/use-company-seals-data.ts'
import SealAdminTable from '@/components/deepSign/sealSettings/seal/SealAdminTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepsign.seal.seal_settings.users',
  },
})

const { permissions } = useAuthorizationContext()
const { selectedOrganizationId } = useAccountMembershipsContext()
const { showSealSettings, isSuccess } = useCompanySealEntriesData(
  selectedOrganizationId,
)

usePageAccess(
  computed(() => !permissions.canManageCertificates || !showSealSettings.value),
  '/organizations/[organizationId]/settings',
  computed(() => !isSuccess.value),
)
</script>
